module.exports = __webpack_public_path__ + "img/Mb_Exhibition_Logo.cf7372e4.png";